/**
 * Delete button for custom icons - X in circle style
 */

import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';

const DeleteIconButton = ({ onClick, isDeleting }) => (
  <button
    className="ip-btn__delete"
    onClick={onClick}
    title="Delete icon"
    disabled={isDeleting}
  >
    {isDeleting ? (
      <FontAwesomeIcon icon={faSpinner} spin size="xs" />
    ) : (
      <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
        <circle
          cx="9"
          cy="9"
          r="7"
          fill="#1a1a2e"
          stroke="rgba(255, 255, 255, 0.7)"
          strokeWidth="1.5"
        />
        <line
          x1="6"
          y1="6"
          x2="12"
          y2="12"
          stroke="rgba(255, 255, 255, 0.9)"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <line
          x1="12"
          y1="6"
          x2="6"
          y2="12"
          stroke="rgba(255, 255, 255, 0.9)"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
      </svg>
    )}
  </button>
);

export default DeleteIconButton;

